import React, { useMemo, useState } from "react";
import TranslationWrapper from "../../../../../components/TranslationWrapper/TranslationWrapper.tsx";

import { FormControl, FormLabel, Select } from "@mui/material";
import { Clear } from "@mui/icons-material";

import Button from "../../../../../components/CustomButtons/Button";
import CustomInput from "../../../../../components/CustomInput/CustomInput";
import SaveButton from "../../../../../components/CustomInput/SaveButton";
import GridContainer from "../../../../../components/Grid/GridContainer";
import GridItem from "../../../../../components/Grid/GridItem";

import { convertArrayToSelectOptions } from "../../../../../templateHelpers";
import AsynchronousAutocomplete from "../../../../../components/Autocomplete/AsynchronousAutocomplete";
import { useFormContext } from "react-hook-form";

function Menukaart(props) {
  const [output, setOutput] = useState({
    type: "menukaart",
    categorie: "eten",
    name: "",
    menukaartid: 0,
    rid: 1,
    ...props.value,
  });
  const [value, setValue] = useState(null);
  const { vestigingId } = useFormContext();

  const save = (e) => {
    e.preventDefault();
    let row = { ...output };

    /**
     * Hacky omdat ik anders de oude value niet meer weer even toevoegen aan de onsave
     */
    if (props.value !== undefined) {
      row.oldName = props.value.name;
    }

    props.onSave(row);
    props.closeForm();
  };

  const handleInputChange = (name, value) => {
    let newOutput = { ...output };
    newOutput[name] = value;
    setOutput(newOutput);
  };

  const categorien = useMemo(
    () => [
      { value: "eten", label: "Eten" },
      { value: "drinken", label: "Drinken" },
    ],
    []
  );

  const categorienOpties = useMemo(() => convertArrayToSelectOptions(categorien), []);

  return (
    <div style={{ background: "#f9f9f9", width: "100%" }}>
      <GridContainer>
        <GridItem sm={2} xs={12}>
          <FormLabel>
            <TranslationWrapper tDefault={"Naam"} tKey={"vestigingen.form.custombutton.menukaart.label.name"} />
          </FormLabel>
        </GridItem>
        <GridItem sm={10} xs={12}>
          <CustomInput
            formControlProps={{
              fullWidth: true,
            }}
            id={"naam"}
            inputProps={{
              type: "text",
              value: output.name,
              onChange: (e) => handleInputChange("name", e.target.value),
            }}
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem sm={2} xs={12}>
          <FormLabel>
            <TranslationWrapper
              tDefault={"Categorie"}
              tKey={"vestigingen.form.custombutton.menukaart.label.categorie"}
            />
          </FormLabel>
        </GridItem>
        <GridItem sm={10} xs={12}>
          <FormControl fullWidth>
            <Select onChange={(e) => handleInputChange("categorie", e.target.value)} value={output.categorie}>
              {categorienOpties}
            </Select>
          </FormControl>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem sm={2} xs={12}>
          <FormLabel>
            <TranslationWrapper
              tDefault={"Menukaart"}
              tKey={"vestigingen.form.custombutton.menukaart.label.menukaartid"}
            />
          </FormLabel>
        </GridItem>
        <GridItem sm={10} xs={12}>
          <FormControl fullWidth>
            <AsynchronousAutocomplete
              async={{
                url:
                  "core/kaarten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  vestigingId,
                searchField: "naam",
              }}
              multiple={false}
              nullable={false}
              onChange={(e, value) => {
                setValue(value?.value);
                setOutput({ ...output, ...{ menukaartName: value.label, menukaartid: value.value } });
              }}
              value={
                (typeof value == "object" ? value : { value }) ??
                (value ? JSON.parse(value).map((id) => ({ value: id })) : null)
              }
            />
            {/*<Select*/}
            {/*  MenuProps={{*/}
            {/*    className: classes.selectMenu,*/}
            {/*  }}*/}
            {/*  classes={{*/}
            {/*    select: classes.select,*/}
            {/*  }}*/}
            {/*  value={this.state.output.menukaartid}*/}
            {/*  onChange={(e) => this.handleInputChange("menukaartid", e.target.value)}*/}
            {/*>*/}
            {/*  {menukaartenOpties}*/}
            {/*</Select>*/}
          </FormControl>
        </GridItem>
      </GridContainer>

      <GridContainer justify={"flex-end"}>
        <GridItem>
          <Button color={"danger"} onClick={props.closeForm}>
            <Clear /> <TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />
          </Button>
          <SaveButton
            buttonText={
              props.value === undefined ? (
                <TranslationWrapper tDefault={"Opslaan"} tKey={"global.button.opslaan"} />
              ) : (
                <TranslationWrapper tDefault={"Aanpassen"} tKey={"global.button.aanpassen"} />
              )
            }
            hasError={false}
            onClick={save}
            saving={false}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default Menukaart;
